/**
 * IDs are used to prepare appropriate error code if there are any api error comes
 * Ids are defined in the comment here: https://paypro.atlassian.net/browse/HYD-386
 */
var ids = {
    merchant: '01',
    agreementAdd: '02',
    agreementEdit: '03',
    loan: '04',
    loanCancel: '05',
    loanEdit: '06',
    loanSign: '07',
    loanSignVerify: '08',
    tokenCreate: '09',
    messageSend: '10',
    loanDocument: '11',
    eventClick: '12',
    loanOffer: '13',
    reportGenerate: '14',
    discountValidate: '15',
};
export var apiPaths = {
    merchant: {
        id: ids.merchant,
        path: function (hash) { return "/merchant/".concat(hash); },
    },
    internal: {
        hash: {
            path: '/internal/hash',
        },
    },
    loan: {
        id: ids.loan,
        path: '/loan',
        edit: {
            id: ids.loanEdit,
            path: '/loan/edit',
        },
        cancel: {
            id: ids.loanCancel,
            path: '/loan/cancel',
        },
        sign: {
            id: ids.loanSign,
            path: '/loan/sign',
            verify: {
                id: ids.loanSignVerify,
                path: '/loan/sign/verify',
            },
        },
        document: {
            id: ids.loanDocument,
            path: function (id) { return "/loan/".concat(id, "/document"); },
        },
        offer: {
            id: ids.loanOffer,
            path: '/loan/offer',
        },
    },
    token: {
        create: {
            id: ids.tokenCreate,
            path: '/token/create',
        },
    },
    agreement: {
        add: {
            id: ids.agreementAdd,
            path: '/agreement/add',
        },
        edit: {
            id: ids.agreementEdit,
            path: '/agreement/edit',
        },
    },
    message: {
        send: {
            id: ids.messageSend,
            path: '/message/send',
        },
    },
    report: {
        generate: {
            id: ids.reportGenerate,
            path: '/report',
        },
    },
    event: {
        click: {
            id: ids.eventClick,
            path: '/event/click',
        },
    },
    discount: {
        validate: {
            id: ids.discountValidate,
            path: '/discount/validate',
        },
    },
};
